import { useState } from "react";
import { Button, ButtonVariant, Modal, Show } from "shared/components";
import { getFullName } from "shared/utils/get-full-name";
import { getApplicantRole } from "utils/getApplicantRole";
import { IntroView } from "./slices/IntroView";
import { RequestSentView } from "../ReverifyIncomeModal/slices/RequestSentView";
import { useCombinedIncomeContext } from "../../providers/useCombinedIncome";

enum Views {
  Intro,
  RequestSent
}

interface Props {
  opened: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export const RerunIncomeModal = ({ opened, onClose, onSuccess }: Props) => {
  const [view, setView] = useState<Views>(Views.Intro);
  const { rerun, isRerunning, applicant, verificationData } =
    useCombinedIncomeContext();

  const applicantFullName = getFullName({
    firstName: applicant.first_name,
    middleName: applicant.middle_name,
    lastName: applicant.last_name,
    short: true
  });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="max-w-[488px] w-full flex flex-col"
    >
      <div className="flex-grow min-h-0">
        <Show if={view === Views.Intro}>
          <IntroView
            onClose={onClose}
            applicantFullName={applicantFullName}
            applicantRole={getApplicantRole(applicant.role)}
            email={applicant.email}
            phone={applicant.phone}
            cents={verificationData?.schema?.screening_fee_cents || 0}
          />
        </Show>

        <Show if={view === Views.RequestSent}>
          <RequestSentView onClose={onClose} />
        </Show>
      </div>

      <Show if={view === Views.Intro}>
        <div className="px-6 py-4 border-t border-alpha-100 gap-2 flex justify-end self-end w-full">
          <Button className="w-[125px]" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant={ButtonVariant.PRIMARY}
            className="w-[160px]"
            loading={isRerunning}
            onClick={() =>
              rerun(undefined, {
                onSuccess: () => {
                  setView(Views.RequestSent);
                  onSuccess?.();
                }
              })
            }
          >
            Send request
          </Button>
        </div>
      </Show>
    </Modal>
  );
};
